import * as h from "react";
import { i as v, b as g, E as u, x as s, r as p, c as m } from "../createReactComponent-58f9bea8.mjs";
import { n as l } from "../property-9daa16cd.mjs";
import { r as w } from "../state-7560d4dc.mjs";
import { e as S } from "../query-d94c86d2.mjs";
import { e as f } from "../class-map-2994e95e.mjs";
import { o as N } from "../style-map-c3339321.mjs";
import { S as T } from "../slot-controller-fa97ce97.mjs";
import { r as A } from "../icon-c572aa57.mjs";
import { r as B } from "../button-7600b6ca.mjs";
import { r as M } from "../tooltip-cb602d1f.mjs";
import { r as z } from "../icon-button-87ac6b5d.mjs";
import { r as j } from "../avatar-e534285e.mjs";
import "../base-e16d29d8.mjs";
var D = Object.defineProperty, I = Object.getOwnPropertyDescriptor, o = (r, e, a, t) => {
  for (var n, d = t > 1 ? void 0 : t ? I(e, a) : e, y = r.length - 1; y >= 0; y--)
    (n = r[y]) && (d = (t ? n(e, a, d) : n(d)) || d);
  return t && d && D(e, a, d), d;
};
class _ extends u {
  constructor() {
    super(...arguments), this.selected = !1, this.disabled = !1, this.label = "", this.haveBorder = !1;
  }
  onKeyPress(e) {
    e.code === "Enter" && this.onSelection();
  }
  onSelection() {
    this.dispatchCustomEvent("onItemSelection", {});
  }
  handleChange() {
    var e, a;
    this.selected ? (e = this.querySelector("ex-leftmenubar-table-row")) == null || e.setAttribute("selected", "") : (a = this.querySelector("ex-leftmenubar-table-row")) == null || a.removeAttribute("selected");
  }
  firstUpdated() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot"), a = e == null ? void 0 : e.assignedNodes();
    this.haveBorder = (a == null ? void 0 : a.length) !== 0;
  }
  render() {
    return this.handleChange(), s`
      <span
        @click=${this.onSelection}
        @keypress=${this.onKeyPress}
        tabindex=${this.disabled ? "-1" : "0"}
        role="menuitem"
        ?selected=${this.selected}
        ?disabled=${this.disabled}
        aria-current=${this.selected ? "page" : "location"}
        aria-disabled=${this.disabled}
        ?bordered=${this.haveBorder}
      >
        <slot> ${this.label} </slot>
      </span>
    `;
  }
}
_.styles = v`
    ${g(`:host span{display:block;background-color:var(--exo-color-background);border-left:var(--exo-spacing-2x-small) solid var(--exo-color-background);padding:var(--exo-spacing-x-small) var(--exo-spacing-large);font:var(--exo-text-label-standard);cursor:pointer}:host span:hover{background-color:var(--exo-color-background-action-hover-weak);border-left:var(--exo-spacing-2x-small) solid var(--exo-color-background-action-hover-weak);padding:var(--exo-spacing-x-small) var(--exo-spacing-large);color:var(--exo-color-font)}:host span:focus-visible{background-color:var(--exo-color-background-action-hover-weak);outline:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected);outline-offset:calc(-.5 * var(--exo-spacing-3x-small));color:var(--exo-color-font)}:host span[selected]{background-color:var(--exo-color-background-selected-weak);border-left:var(--exo-spacing-2x-small) solid var(--exo-color-border-tertiary);color:var(--exo-color-font);cursor:default;font:var(--exo-text-label-standard-semi-bold);pointer-events:none;padding:var(--exo-spacing-x-small) var(--exo-spacing-medium)}:host span[selected]:focus-visible{outline:none}:host span[disabled]{color:var(--exo-color-font-disabled);pointer-events:none;cursor:not-allowed}:host span[bordered]{border-bottom:var(--exo-spacing-4x-small) solid var(--exo-color-border);padding:var(--exo-spacing-medium) var(--exo-spacing-medium)}:host span:hover ::slotted(ex-leftmenubar-table-row),:host span:focus-visible ::slotted(ex-leftmenubar-table-row),:host span[selected] ::slotted(ex-leftmenubar-table-row),:host span[disabled] ::slotted(ex-leftmenubar-table-row){color:inherit}
`)}
  `, o([l({ type: Boolean, reflect: !0 })], _.prototype, "selected", 2), o([l({ type: Boolean, reflect: !0 })], _.prototype, "disabled", 2), o([l({ type: String })], _.prototype, "label", 2), o([w()], _.prototype, "haveBorder", 2);
class C extends u {
  constructor() {
    super(...arguments), this.label = "";
  }
  render() {
    return s`
      <span>
        <slot> ${this.label} </slot>
      </span>
    `;
  }
}
C.styles = v`
    ${g(`:host span{display:block;background-color:var(--exo-color-background);padding:var(--exo-spacing-x-small) var(--exo-spacing-large);font:var(--exo-text-label-standard-bold);color:var(--exo-color-font)}
`)}
  `, o([l({ type: String })], C.prototype, "label", 2);
class c extends u {
  constructor() {
    super(...arguments), this.selected = !1, this.disabled = !1, this.dropdownitem = !1, this.label = "", this.tooltipText = "Main Menu Item", this.isCollapsed = !1, this.haveBorder = !1, this.slotController = new T(this, "icon");
  }
  onSelection() {
    this.dispatchCustomEvent("onItemSelection", {});
  }
  labelWithTooltip() {
    if (this.label.length > 32) {
      const e = `${this.label.substring(0, 32)}...`;
      return s`
        <ex-tooltip tooltipDelay="1">
          <div style="white-space: initial; word-break: break-word;">
            ${this.label}
          </div>
          <div
            slot="anchor"
            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
          >
            ${e}
          </div>
        </ex-tooltip>
      `;
    }
    return s`${this.label}`;
  }
  menuItemTemplate() {
    return s`
      <span
        @click=${this.onSelection}
        tabindex=${this.disabled ? "-1" : "0"}
        role="menuitem"
        ?selected=${this.selected}
        ?disabled=${this.disabled}
        aria-current=${this.selected ? "page" : "location"}
        aria-disabled=${this.disabled}
        part="leftmenubar-item ${this.selected}"
        class=${f({ leftmenubar__link: !0, "leftmenubar__link--collapsed": this.isCollapsed })}
      >
        <div
          class=${f({ "child-item-spacer": !0, leftmenubar__icon: this.slotController.test("icon") })}
        >
          <slot name="icon"></slot>
        </div>
        ${this.isCollapsed ? "" : s`<div class="leftmenubar-label">
              ${this.labelWithTooltip()}
            </div>`}
      </span>
    `;
  }
  getLeftmenubarLink() {
    return this.isCollapsed ? s`
          <ex-tooltip position="right" alignment="middle">
            <div>${this.tooltipText}</div>
            <div slot="anchor">${this.menuItemTemplate()}</div>
          </ex-tooltip>
        ` : this.menuItemTemplate();
  }
  render() {
    return this.getLeftmenubarLink();
  }
}
c.styles = v`
    ${g(`:host{--exo-component-leftmenubar-child-item-spacer: 38px}:host .child-item-spacer{width:var(--exo-component-leftmenubar-child-item-spacer)}:host span{display:flex;align-items:center;box-sizing:border-box;height:40px;background-color:var(--exo-color-background);padding:var(--exo-spacing-none) var(--exo-spacing-x-small) var(--exo-spacing-none) var(--exo-spacing-2x-small);font:var(--exo-text-label-standard);color:var(--exo-color-font);cursor:pointer;overflow:hidden;border-radius:var(--exo-spacing-2x-small);gap:var(--exo-spacing-3x-small)}:host span:hover{background-color:var(--exo-color-background-action-hover-weak)}:host span[selected]{display:flex;align-items:center;cursor:default;font:var(--exo-text-label-standard-semi-bold);position:relative;border-top-left-radius:0;border-bottom-left-radius:0;gap:2px}:host span[selected]:hover{background:var(--exo-color-background-action-secondary-hover)}:host span[selected]:focus-visible{outline:none;border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected);border-radius:var(--exo-spacing-2x-small);background:var(--exo-color-background-action-secondary-hover)}:host span[selected]:before{content:"";height:var(--exo-spacing-large);border-radius:var(--exo-radius-small);background:var(--exo-color-background-selected);width:var(--exo-spacing-3x-small);position:absolute;left:0;transition:height var(--exo-time-standard) ease}:host span[selected]:hover:before,:host span[selected]:focus-visible:before{height:calc(2 * var(--exo-spacing-medium));box-sizing:border-box;border-radius:var(--exo-spacing-none)}:host span[selected] .leftmenubar-label{font:var(--exo-text-label-standard-semi-bold)}:host span .leftmenubar-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--exo-color-font);font:var(--exo-text-label-standard);padding:var(--exo-spacing-2x-small) var(--exo-spacing-x-small) var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)}:host span[disabled]{display:flex;align-items:center;color:var(--exo-color-font-disabled);pointer-events:none;cursor:not-allowed}:host span[disabled] .leftmenubar-label{color:var(--exo-color-font-disabled)}:host span:focus-visible{background-color:var(--exo-color-background-action-hover-weak);outline:none;border:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover)}:host span:hover ::slotted(ex-leftmenubar-table-row),:host span:focus-visible ::slotted(ex-leftmenubar-table-row),:host span[selected] ::slotted(ex-leftmenubar-table-row),:host span[disabled] ::slotted(ex-leftmenubar-table-row){color:inherit}:host span[bordered]{border-bottom:var(--exo-spacing-4x-small) solid var(--exo-color-border);padding:var(--exo-spacing-medium) var(--exo-spacing-medium)}:host span .leftmenubar__icon{display:flex;font-size:var(--exo-font-size-3x-large);width:32px;height:32px;color:var(--exo-color-background-deselected);align-items:center;justify-content:center}:host span .leftmenubar__icon:hover{color:var(--exo-color-background-deselected-hover)}:host .leftmenubar__link.leftmenubar__link--collapsed{padding:var(--exo-spacing-none) var(--exo-spacing-2x-small);justify-content:center;width:40px}:host span:hover .leftmenubar__icon{color:var(--exo-color-background-deselected-hover)}:host span[selected] .leftmenubar__icon{color:var(--exo-color-background-selected)}
`)}
  `, o([l({ type: Boolean, reflect: !0 })], c.prototype, "selected", 2), o([l({ type: Boolean, reflect: !0 })], c.prototype, "disabled", 2), o([l({ type: Boolean, reflect: !0 })], c.prototype, "dropdownitem", 2), o([l({ type: String })], c.prototype, "label", 2), o([l({ type: String })], c.prototype, "tooltipText", 2), o([l({ type: Boolean })], c.prototype, "isCollapsed", 2), o([w()], c.prototype, "haveBorder", 2);
class $ extends u {
  onToggle(e) {
    const a = e.target;
    this.items.forEach((t, n) => {
      t !== a ? t.selected = !1 : (t.selected = !0, this.dispatchCustomEvent("onSelectionChange", { selectedIndex: n }));
    });
  }
  firstUpdated() {
    this.items = Array.prototype.slice.call(this.children), this.items.forEach((e) => {
      e.addEventListener("onItemSelection", (a) => this.onToggle(a));
    }), this.setAttribute("role", "menu");
  }
  render() {
    return s`<slot></slot>`;
  }
}
$.styles = v`
    ${g(`:host{overflow-x:auto}
`)}
  `;
class k extends u {
  constructor() {
    super(...arguments), this.label = "", this.tag = "";
  }
  render() {
    return s`
      <div>
        <div class="leftmenubar-table-row leftmenubar-table-header">
          <div class="leftmenubar-table-label" part="lmbi-label">
            ${this.label}
          </div>
          <div class="leftmenubar-table-tag">${this.tag}</div>
        </div>
        <div class="leftmenubar-table-row"><slot></slot></div>
      </div>
    `;
  }
}
k.styles = v`
    ${g(`:host .leftmenubar-table-row{display:flex;box-sizing:border-box;justify-content:space-between;gap:var(--exo-spacing-x-large)}:host .leftmenubar-table-header{margin-bottom:var(--exo-spacing-large)}:host{color:var(--exo-color-font-secondary);font:var(--exo-text-body-small)}:host .leftmenubar-table-label{color:var(--exo-color-font);font-size:var(--exo-font-size-medium)}:host .leftmenubar-table-label,:host .leftmenubar-table-tag{overflow-wrap:anywhere;width:50%}:host .leftmenubar-table-tag{text-align:right}:host([selected]) .leftmenubar-table-label{color:inherit;font-weight:var(--exo-font-weight-bold)}
`)}
  `, o([l({ type: String })], k.prototype, "label", 2), o([l({ type: String })], k.prototype, "tag", 2);
class i extends u {
  constructor() {
    super(...arguments), this.adjustable = !1, this.expandWidth = 300, this.collapseWidth = 55, this.isCollapse = !1, this.showAvatar = !0, this.firstName = "", this.lastName = "", this.collapsed = !1, this.leftMenuBarLinks = [], this.showUpCaret = !0, this.showDownCaret = !0, this.leftmenuCollapseButton = () => this.isCollapse ? s`<ex-icon-button
          icon="Move right"
          flavor="branded"
          type="tertiary"
          tooltiptext=""
          size="default"
          @click=${this.expandPanel}
        ></ex-icon-button>` : s`<ex-button
          flavor="branded"
          type="tertiary"
          size="default"
          buttonType="button"
          @click=${this.collapsePanel}
          class="leftmenubar__collapse-span"
          role="menuitem"
          ><ex-icon size="XS" icon="Move left" slot="prefix"></ex-icon
          >Collapse</ex-button
        >`, this.getLeftMenuAvatar = () => this.showAvatar ? this.leftmenuAvatar() : "", this.leftmenuAvatar = () => {
      const e = s`<ex-avatar
      avatartype="user"
      accountname="accountname"
      firstname=${this.firstName}
      lastname=${this.lastName}
      size="small"
    ></ex-avatar>`;
      return this.isCollapse ? e : s`${e}<span>${this.firstName}</span>`;
    };
  }
  getSlottedElements() {
    return [...this.defaultSlot.assignedElements({ flatten: !1 })];
  }
  handlePanelLabelStyle(e) {
    this.getSlottedElements().forEach((a) => {
      const { shadowRoot: t } = a;
      if (t) {
        const n = t.querySelector(".leftmenubar__dropdown-label"), d = t.querySelector(".leftmenubar__dropdown-caret"), y = t.querySelector(".leftmenubar-label");
        y instanceof HTMLElement && (y.style.display = e), n instanceof HTMLElement && (n.style.display = e), d instanceof HTMLElement && (d.style.display = e);
      }
    });
  }
  updateSlottedElementAttributes({ isCollapsed: e = !1 }) {
    this.getSlottedElements().forEach((a) => {
      a.tagName.toUpperCase() !== "EX-LEFTMENUBAR-DROPDOWN" && a.tagName.toUpperCase() !== "EX-LEFTMENUBAR-LINK" || (e ? a.setAttribute("isCollapsed", "true") : a.removeAttribute("isCollapsed"));
    });
  }
  dispatchCollapseEvent() {
    this.dispatchCustomEvent("on-collapse", { detail: { data: { ...this.dataset }, collapse: this.isCollapse } });
  }
  collapsePanel() {
    this.isCollapse = !0, this.collapsed = !0, this.handlePanelLabelStyle("none"), this.updateSlottedElementAttributes({ isCollapsed: this.isCollapse }), this.dispatchCollapseEvent();
  }
  expandPanel() {
    this.isCollapse = !1, this.collapsed = !1, this.handlePanelLabelStyle("block"), this.updateSlottedElementAttributes({ isCollapsed: this.isCollapse }), this.dispatchCollapseEvent();
  }
  scrollUp() {
    this.scrollContainer && (this.scrollContainer.scrollTop -= 50);
  }
  scrollDown() {
    this.scrollContainer && (this.scrollContainer.scrollTop += 50);
  }
  updated(e) {
    var a;
    if (super.updated(e), this.isCollapse) {
      const t = this == null ? void 0 : this.querySelectorAll("ex-leftmenubar-dropdown");
      t == null || t.forEach((n) => {
        n.getAttribute("open") === "" && n.removeAttribute("open");
      });
    }
    if (e.has("isCollapse") && !this.isCollapse) {
      const t = this.querySelectorAll("ex-leftmenubar-link");
      t == null || t.forEach((n) => {
        var d;
        n.getAttribute("selected") === "" && n.getAttribute("open") !== "" && ((d = n.parentNode) == null || d.setAttribute("open", ""));
      });
    }
    e.has("isCollapse") && ((a = this.shadowRoot) == null || a.addEventListener("on-toggle", () => {
      this.expandPanel();
    }));
  }
  setSelectedAttributeForDropdownElement({ item: e, isSelected: a = !1 }) {
    e.parentNode.tagName.toUpperCase() === "EX-LEFTMENUBAR-DROPDOWN" && a && e.parentNode.setAttribute("selected", "true");
  }
  onToggle(e) {
    const a = e.target;
    this.querySelectorAll("ex-leftmenubar-dropdown").forEach((t) => t.removeAttribute("selected")), this.leftMenuBarLinks.forEach((t) => {
      const n = t === a;
      t.selected = n, this.setSelectedAttributeForDropdownElement({ item: t, isSelected: n });
    });
  }
  firstUpdated() {
    this.leftMenuBarLinks = this.querySelectorAll("ex-leftmenubar-link"), this.leftMenuBarLinks.forEach((e) => {
      e.addEventListener("onItemSelection", this.onToggle.bind(this));
    }), this.setAttribute("role", "menu"), this.updateSlottedElementAttributes({ isCollapsed: this.isCollapse }), this.scrollContainer.addEventListener("scroll", () => this.checkScrollPosition()), this.checkScrollPosition();
  }
  checkScrollPosition() {
    if (this.scrollContainer) {
      const { scrollTop: e, scrollHeight: a, clientHeight: t } = this.scrollContainer;
      this.showUpCaret = e > 0, this.showDownCaret = e < a - t - 1;
    }
  }
  render() {
    const e = { width: (() => this.isCollapse ? `${this.collapseWidth}px` : `${this.expandWidth}px`)() };
    return s`
      <div
        class=${f({ leftmenubar__adjustable: !0, collapsed: this.collapsed })}
        style=${N(e)}
      >
        ${this.collapsed && this.showUpCaret ? s`<span class="icon-button-wrapper">
              <ex-icon-button
                icon="Up caret"
                flavor="branded"
                type="tertiary"
                tooltiptext=""
                size="small"
                circular=""
                hide-browser-tooltip=""
                @click=${this.scrollUp}
              ></ex-icon-button>
            </span>` : ""}
        <div class="leftmenubar__menu">
          <slot></slot>
        </div>
        ${this.collapsed && this.showDownCaret ? s`<span class="icon-button-wrapper">
              <ex-icon-button
                icon="Down caret"
                flavor="branded"
                type="tertiary"
                tooltiptext=""
                size="small"
                circular=""
                hide-browser-tooltip=""
                @click=${this.scrollDown}
              ></ex-icon-button>
            </span>` : ""}
        <div
          class=${f({ "leftmenubar__secondary-nav-content": !0, collapsed: this.collapsed })}
        >
          <div class="leftmenubar__avatar">${this.getLeftMenuAvatar()}</div>
          ${this.adjustable ? s`<ex-leftmenubar-divider></ex-leftmenubar-divider>
                <div
                  class=${f({ "leftmenubar__collapse-button": !0, "leftmenubar__collapse-button-hide": !this.adjustable })}
                >
                  ${this.leftmenuCollapseButton()}
                </div>` : ""}
        </div>
      </div>
    `;
  }
}
i.styles = v`
    ${g(`:host .leftmenubar__adjustable{height:100%;background-color:var(--exo-color-background);overflow-x:hidden;position:relative;border-right:var(--exo-spacing-4x-small) solid var(--exo-color-border);display:flex;justify-content:space-between;flex-direction:column}:host .leftmenubar__adjustable.collapsed{align-items:center}:host .leftmenubar__collapse-button{display:flex;width:100%;cursor:pointer;overflow-x:hidden;justify-content:flex-start;align-items:center;padding:8px 0}.leftmenubar__collapse-button-hide{display:none}.leftmenubar__collapse-span{display:flex;align-items:center;cursor:pointer;font:var(--exo-text-label-standard);color:var(--exo-color-font)}:host ex-icon::part(icon){margin-right:calc(var(--exo-spacing-medium) * .5);margin-left:var(--exo-spacing-2x-small);font-size:var(--exo-font-size-3x-large);width:var(--exo-spacing-large)}:host .leftmenubar__menu{height:90%;padding:8px;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none}:host .leftmenubar__menu::-webkit-scrollbar{display:none}:host .leftmenubar__avatar{display:flex;gap:var(--exo-spacing-3x-small);padding:var(--exo-spacing-none) var(--exo-spacing-x-small) var(--exo-spacing-none) var(--exo-spacing-2x-small);height:40px;align-items:center}:host .leftmenubar__avatar span{padding:var(--exo-spacing-2x-small) var(--exo-spacing-x-small) var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)}:host .leftmenubar__secondary-nav-content{display:flex;flex-direction:column;padding:8px 8px 0;gap:var(--exo-spacing-3x-small)}:host .leftmenubar__secondary-nav-content.collapsed .leftmenubar__collapse-button{display:flex;justify-content:center}:host .icon-button-wrapper{display:flex;align-items:center;padding-top:8px}
`)}
  `, o([l({ type: Boolean })], i.prototype, "adjustable", 2), o([l({ type: Number })], i.prototype, "expandWidth", 2), o([l({ type: Number })], i.prototype, "collapseWidth", 2), o([l({ type: Boolean })], i.prototype, "isCollapse", 2), o([l({ type: Boolean, reflect: !0 })], i.prototype, "showAvatar", 2), o([l({ type: String, reflect: !0 })], i.prototype, "firstName", 2), o([l({ type: String, reflect: !0 })], i.prototype, "lastName", 2), o([w()], i.prototype, "collapsed", 2), o([S("slot")], i.prototype, "defaultSlot", 2), o([S(".leftmenubar__menu")], i.prototype, "scrollContainer", 2), o([w()], i.prototype, "showUpCaret", 2), o([w()], i.prototype, "showDownCaret", 2);
class L extends u {
  render() {
    return s`
      <div class="leftmenubar--table-col">
        <slot></slot>
      </div>
    `;
  }
}
class E extends u {
  render() {
    return s` <hr class="leftmenu__divider" noshade />`;
  }
}
E.styles = v`
    ${g(`:host hr.leftmenu__divider{margin:2px 8px;height:var(--exo-spacing-none);border-top:var(--exo-spacing-none);border-color:var(--exo-color-border-secondary)}
`)}
  `;
class b extends u {
  constructor() {
    super(...arguments), this.label = "", this.tooltipText = "Main Menu Item", this.open = !1, this.disabled = !1, this.isCollapsed = !1, this.selected = !1;
  }
  firstUpdated() {
    this.addEventListener("onItemSelection", this.handleChildSelection.bind(this));
  }
  onClick(e) {
    this.disabled || (this.toggle(), this.dispatchCustomEvent("on-toggle", { detail: { data: { ...this.dataset }, label: this.label, open: this.open } }), e.currentTarget.focus());
  }
  toggle() {
    this.open = !this.open;
  }
  handleChildSelection() {
    this.selected = !0;
  }
  renderIcon() {
    return s`
      <div
        class=${f({ "leftmenubar__dropdown-icon": !0, "leftmenubar__dropdown--collapse--selected": this.isCollapsed && this.selected })}
        slot="anchor"
      >
        <slot name="icon"></slot>
      </div>
    `;
  }
  renderHeader() {
    return s`
      <div
        @click=${this.onClick}
        class=${f({ "leftmenubar__dropdown-header": !0, "leftmenubar__dropdown--header--collapsed": this.isCollapsed, "leftmenubar__dropdown--header--selected": this.selected })}
        role="menuitem"
        tabindex=${this.disabled ? "-1" : "0"}
      >
        ${this.renderIcon()} ${this.isCollapsed ? "" : this.renderLabel()}
      </div>
    `;
  }
  renderLabel() {
    return s`
      <h5 aria-expanded=${this.open} class="leftmenubar__dropdown-label">
        ${this.label}
      </h5>
      <ex-icon
        icon="Down caret"
        size="XS"
        ?variant=${this.disabled ? "disabled" : void 0}
        class="leftmenubar__dropdown-caret"
      ></ex-icon>
    `;
  }
  renderHeaderWithTooltip() {
    return s`
      <ex-tooltip
        position="right"
        alignment="middle"
        class="leftmenubar__dropdown-header-tooltip"
      >
        <div>${this.tooltipText}</div>
        <div slot="anchor">${this.renderHeader()}</div>
      </ex-tooltip>
    `;
  }
  render() {
    return s`
      <div
        class=${f({ leftmenubar__dropdown: !0, "leftmenubar__dropdown--disabled": this.disabled, "leftmenubar__dropdown--dropdown--selected": this.isCollapsed && this.selected })}
      >
        ${this.isCollapsed ? this.renderHeaderWithTooltip() : this.renderHeader()}
        <div id="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
b.styles = v`
    ${g(`:host .leftmenubar__dropdown{background:var(--exo-color-background);cursor:pointer}:host .leftmenubar__dropdown-header{display:flex;align-items:center;box-sizing:border-box;gap:var(--exo-spacing-3x-small);border-radius:var(--exo-spacing-2x-small);height:calc(.5 * var(--exo-size-1));padding:0 var(--exo-spacing-x-small)}:host .leftmenubar__dropdown-header:hover{background:var(--exo-color-background-action-hover-weak)}:host .leftmenubar__dropdown-header:focus-visible{background:var(--exo-color-background-action-hover-weak);outline:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover)}:host .leftmenubar__dropdown-header.leftmenubar__dropdown--header--collapsed{justify-content:center;width:40px}:host .leftmenubar__dropdown-label{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:inherit;box-sizing:border-box;width:100%;text-align:left;color:var(--exo-color-font);margin:calc(-2 * var(--exo-spacing-4x-small));padding:4px 8px 4px 4px;font:var(--exo-text-label-standard)}:host .leftmenubar__dropdown-icon{display:flex;align-items:center;padding:var(--exo-spacing-3x-small);width:40px;height:40px;font-size:24px;color:var(--exo-color-background-deselected);justify-content:center}:host .leftmenubar__dropdown-header:hover .leftmenubar__dropdown-icon,:host .leftmenubar__dropdown-header:focus-visible .leftmenubar__dropdown-icon{color:var(--exo-color-background-deselected-hover)}:host .leftmenubar__dropdown--header--selected:hover .leftmenubar__dropdown-icon,:host .leftmenubar__dropdown--header--selected:focus-visible .leftmenubar__dropdown-icon{color:var(--exo-color-background-selected-hover)}:host .leftmenubar__dropdown--header--selected .leftmenubar__dropdown-label{font:var(--exo-text-label-standard-semi-bold)}:host .leftmenubar__dropdown-caret{display:flex;padding:var(--exo-spacing-2x-small);align-items:center;box-sizing:border-box;color:var(--exo-color-background-deselected)}:host .leftmenubar__dropdown-caret:hover,:host .leftmenubar__dropdown-caret:focus-visible{color:var(--exo-color-background-deselected-hover)}:host .leftmenubar__dropdown-header:hover .leftmenubar__dropdown-caret,:host .leftmenubar__dropdown-header:focus-visible .leftmenubar__dropdown-caret{color:var(--exo-color-background-deselected-hover)}:host([open]) .leftmenubar__dropdown-caret{transform:rotate(180deg);background:var(--exo-color-background-secondary);border-radius:var(--exo-spacing-2x-small)}:host #content{display:none}:host([open]) #content{display:block}:host .leftmenubar__dropdown--disabled{pointer-events:none;color:var(--exo-color-font-disabled)}:host .leftmenubar__dropdown--header--selected{display:flex;align-items:center;cursor:default;font:var(--exo-text-label-standard-semi-bold);position:relative;border-top-left-radius:0;border-bottom-left-radius:0;z-index:1}:host .leftmenubar__dropdown--header--selected:hover{background:var(--exo-color-background-action-secondary-hover)}:host .leftmenubar__dropdown--header--selected:focus-visible{border:none;outline:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected);border-radius:var(--exo-spacing-2x-small);background:var(--exo-color-background-action-secondary-hover)}:host .leftmenubar__dropdown--header--selected:before{content:"";height:var(--exo-spacing-large);border-radius:var(--exo-radius-small);background:var(--exo-color-background-selected);width:var(--exo-spacing-3x-small);position:absolute;left:0;transition:height var(--exo-time-standard) ease}:host .leftmenubar__dropdown--header--selected:hover:before,:host .leftmenubar__dropdown--header--selected:focus-visible:before{height:calc(2 * var(--exo-spacing-medium));box-sizing:border-box;border-radius:var(--exo-spacing-none)}:host .leftmenubar__dropdown--header--selected .leftmenubar__dropdown-icon{color:var(--exo-color-background-selected)}:host .leftmenubar__dropdown--header--selected .leftmenubar__dropdown-icon:hover,:host .leftmenubar__dropdown--header--selected .leftmenubar__dropdown-icon:focus{color:var(--exo-color-background-selected-hover)}:host([selected]) .leftmenubar__dropdown-header:hover .leftmenubar__dropdown-caret:not(.leftmenubar__dropdown--header--selected){background:none}
`)}
  `, o([l({ type: String })], b.prototype, "label", 2), o([l({ type: String })], b.prototype, "tooltipText", 2), o([l({ type: Boolean, reflect: !0 })], b.prototype, "open", 2), o([l({ type: Boolean, reflect: !0 })], b.prototype, "disabled", 2), o([l({ type: Boolean })], b.prototype, "isCollapsed", 2), o([l({ type: Boolean, reflect: !0 })], b.prototype, "selected", 2);
const x = (r = "") => {
  p("ex-leftmenubar-item", _, r), p("ex-leftmenubar-category-title", C, r), p("ex-leftmenubar-link", c, r), p("ex-leftmenubar", $, r), p("ex-leftmenubar-table-row", k, r), p("ex-leftmenubar-adjustable", i, r), p("ex-leftmenubar-table-col", L, r), p("ex-leftmenubar-divider", E, r), p("ex-leftmenubar-dropdown", b, r), A(r), B(r), M(r), z(r), j(r);
}, V = m({ tagName: "ex-leftmenubar", elementClass: $, react: h, events: { onSelectionChange: "onSelectionChange" }, displayName: "ExLeftMenubar", registerWebComponent: x }), Y = m({ tagName: "ex-leftmenubar-item", elementClass: _, react: h, events: { onItemSelection: "onItemSelection" }, displayName: "ExLeftMenubarItem", registerWebComponent: x }), Z = m({ tagName: "ex-leftmenubar-table-row", elementClass: k, react: h, events: {}, displayName: "ExLeftMenubarTableRow", registerWebComponent: x }), ee = m({ tagName: "ex-leftmenubar-table-col", elementClass: L, react: h, events: {}, displayName: "ExLeftMenubarTableCol", registerWebComponent: x }), te = m({ tagName: "ex-leftmenubar-category-title", elementClass: C, react: h, events: {}, displayName: "ExLeftmenubarCategoryTitle", registerWebComponent: x }), oe = m({ tagName: "ex-leftmenubar-link", elementClass: c, react: h, events: { onItemSelection: "onItemSelection" }, displayName: "ExLeftmenubarLink", registerWebComponent: x }), ae = m({ tagName: "ex-leftmenubar-adjustable", elementClass: i, react: h, events: { onCollapse: "on-collapse" }, displayName: "ExLeftmenubarAdjustable", registerWebComponent: x }), re = m({ tagName: "ex-leftmenubar-divider", elementClass: E, react: h, events: {}, displayName: "ExLeftmenubarDivider", registerWebComponent: x }), le = m({ tagName: "ex-leftmenubar-dropdown", elementClass: b, react: h, events: { onToggle: "on-toggle" }, displayName: "ExLeftmenubarDropdown", registerWebComponent: x });
export {
  V as ExLeftMenubar,
  Y as ExLeftMenubarItem,
  ee as ExLeftMenubarTableCol,
  Z as ExLeftMenubarTableRow,
  ae as ExLeftmenubarAdjustable,
  te as ExLeftmenubarCategoryTitle,
  re as ExLeftmenubarDivider,
  le as ExLeftmenubarDropdown,
  oe as ExLeftmenubarLink,
  $ as LeftMenubar,
  _ as LeftMenubarItem,
  i as LeftmenubarAdjustable,
  C as LeftmenubarCategoryTitle,
  E as LeftmenubarDivider,
  b as LeftmenubarDropdown,
  c as LeftmenubarLink,
  L as LeftmenubarTableCol,
  k as LeftmenubarTableRow,
  x as register
};
